import React from 'react';
import PropTypes from 'prop-types';

function Seller (props) {
  const item = props.item;
  const author = item.getAuthor();
  const agency = author.getAgency();

  if (!author.isExist()) {
    return <td className='paper col-seller' />;
  }

  return (
    <td className='paper col-seller'>
      {agency && (
        <div
          className='only-user'
          data-tip={'Объявления от ' + agency.getName()}
          onClick={() => props.onUpdateFilter({onlyOwners: null, agencyId: agency.getId()})}>
          { agency.getName() }
        </div>)
      }

      {author.isOwner() && (
        <div
          className='only-user'
          data-tip='Объявления от собственников'
          onClick={() => props.onUpdateFilter({onlyOwners: 1, agencyId: null})}>
          СОБСТВЕННИК
        </div>)
      }
    </td>
  );
}

Seller.propTypes = {
  item: PropTypes.object.isRequired,
  onUpdateFilter: PropTypes.func.isRequired
};

Seller.defaultProps = {};

export default Seller;



// WEBPACK FOOTER //
// ./src/ui/Views/Announcements/Cells/PaperCells/Seller.jsx